package core.extensions

import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.w3c.dom.Window


/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 06.04.23
 * Author : mariorosshirt
 */

inline val Window.webkit: Webkit?
    get() = asDynamic().webkit.unsafeCast<Webkit?>()

inline val Window.appInterface: AppInterface?
    get() = asDynamic().appInterface.unsafeCast<AppInterface?>()

external interface Webkit{
    val messageHandlers: MessageHandlers
}

external interface MessageHandlers {
    val appInterface: AppInterface
}

external interface AppInterface{
    fun postMessage(msg: String)
}

fun Window.isInNativeApp(): Boolean {
    return !(appInterface == null && webkit?.messageHandlers?.appInterface == null)
}

inline fun <reified T> Window.postMessageToNativeApp(message: T) {

    val serializer = Json {
        ignoreUnknownKeys = true
        isLenient = true
    }

    webkit?.messageHandlers?.appInterface?.postMessage(
        serializer.encodeToString(
            message
        )
    )

    appInterface?.postMessage(
        serializer.encodeToString(
            message
        )
    )
}

fun Window.isMobile(): Boolean {
    return this.innerWidth <= 575
}